// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3h_df","hero-story-wrapper":"_17BqA","content-wrapper":"_1LtWc","headline":"_1D9dC","hero-image":"_1adv7","second-row-cards":"_3Z3yw"};